import { PaddedSurface as Surface, WrapLgMarginBottom } from "App/global-style";

import { FormikProps } from "formik";
import React from "react";
import { CoopConsent } from "./CoopConsent";

interface Props {
  formProps: FormikProps<any>;
  isWithSurface?: boolean;
}

export const CoopMembershipConfirmation = ({
  formProps,
  isWithSurface = false,
}: Props): React.ReactElement => {
  if (isWithSurface) {
    return (
      <Surface>
        <CoopConsent formProps={formProps} />
      </Surface>
    );
  }
  return (
    <WrapLgMarginBottom>
      <CoopConsent formProps={formProps} />
    </WrapLgMarginBottom>
  );
};
